module.exports = __webpack_public_path__ + "img/ignis-gls-plus-rojo.033af951.png";